import {Ad} from "./ad";
import {IframeManager} from "./iframeManager";

export class Interstital extends Ad {

    constructor(context, containerId, parameters, ad) {
        super(context, containerId, parameters, ad)
    }

    build() {
        const background = this.ad.background || 'transparent';
        const opacity = this.isAdSpace() ? 0.4 : 1;
        this.container.style.display = 'none';
        this.container.style.position = "absolute";
        this.container.style.left = "0px";
        this.container.style.top = "0px";
        this.container.style.width = this.context.innerWidth + "px";
        this.container.style.height = this.context.innerHeight + "px";

        this.container.innerHTML =
            '<div ' +
            'style="z-index: 10000;position: absolute; left: 0px; top: 0px; background-color: ' + background + '; opacity: ' + opacity + '; display: inline; width: 100%; height: 100%;"   ' +
            ' id="' + this.containerId + 'mpO">' +
            '</div>' +
            this.buildCloseButton() +
            this.buildAdChoice() +
            '<div ' +
            'style="z-index: 10001;position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; background-color: transparent; display: inline; opacity: 1;display: table;" ' +
            ' id="' + this.containerId + 'mpCo">' +
            '<div style="width: 100%; height: 100%;display: table-cell; vertical-align: middle;text-align: center;">' +
            '</div>' +
            '</div>';

        let selector = this.context.document.querySelector('#' + this.containerId + 'mpCo > :last-child');
        switch (this.ad.format) {
            case 'html':
                this.iframeManager = new IframeManager(this);
                const iframe = this.iframeManager.build();
                selector.appendChild(iframe);
                this.iframeManager.addContent(this.ad.content);
                break;
            case 'image':
                selector.appendChild(this.ad.content);
                break;

        }

        this.container.style.display = 'block';
        this.setEvents();
    }


    setEvents() {
        const duration = (parseFloat(this.ad.duration) || 30) * 1000;
        const closeAppearanceDelay = (parseFloat(this.ad.closeAppearanceDelay) || 0) * 1000;
        let the = this;
        this.context.document.getElementById(the.containerId + 'mpC').addEventListener('click', function () {
            the.container.parentNode.removeChild(the.container);
        });

        this.context.setTimeout(function () {
            document.getElementById(the.containerId + 'mpC').style.display = 'inline';
        }, closeAppearanceDelay);

        this.context.setTimeout(function () {
     /*       if( the.container.parentNode) {
                the.container.parentNode.removeChild(the.container);
            }*/
            the.close();
        }, duration);
    }

}
